//
import React from 'react';
import { useSelector } from 'react-redux';

import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterLuxon } from '@mui/x-date-pickers-pro/AdapterLuxon';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { getCurrentTheme } from 'themes/themesSelectors';
import { AdapterLuxonWrapper } from 'utils/AdapterLuxonWrapper';

import GlobalStyles from './global-styles';

// type Props = {
//   children: React.Node,
// };

// eslint-disable-next-line react/prop-types
const CombinedStyleProviders = ({ children }) => {
  const theme = useSelector(getCurrentTheme);
  const dateAdapter =
    navigator.language.endsWith('US') || navigator.language.endsWith('CA') ? AdapterLuxonWrapper : AdapterLuxon;

  return (
    <StyledEngineProvider injectFirst>
      <EmotionThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <CssBaseline enableColorScheme />
          <StyledComponentsThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={dateAdapter}>{children}</LocalizationProvider>
          </StyledComponentsThemeProvider>
        </ThemeProvider>
      </EmotionThemeProvider>
      <GlobalStyles />
    </StyledEngineProvider>
  );
};

export default CombinedStyleProviders;
